import React from "react";
import "./App.css";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import Login from "./pages/Login";
import ColoursEx from "./pages/ColoursEx";
import Meetings from "./pages/Meetings";
import TagMeetings from "./pages/TagMeetings";
import ThankYouPage from "./pages/ThankYouPage";
import RegularizeAttendanceData from "./pages/RegularizeAttendanceData";
import AddConveyance from "./pages/AddConveyance";
import RegularizeMeetingMenu from "./pages/RegularizeMeetingMenuPage";
import RegularizeMeeting from "./pages/RegularizeMeeting";
import MarkMyDayPage from "./pages/MarkMyDayPage";
import ProfilePage from "./pages/ProfilePage";
import ForgotPassword from "./pages/ForgotPassword";
import UploadImdPage from "./pages/UploadImdPage";
import { Toaster } from "sonner";
import { globalRouter } from "./utils/common";
import AuthGuard from "./components/AuthGuard";
import ResetPassword from "./pages/resetPassword";
import Footer from "./components/Footer";
import AddToHomeScreenPrompt from "./pages/AddToHomeScreenPrompt";
import CreateUserPage from "./pages/CreateUserPage";
import DeleteUserPage from "./pages/DeleteUserPage";
import ProtectedRoute from "./utils/ProtectRoutes";

import { useAuth } from "./context/AuthProvider";

function App() {
  const { isLoading, userDetail } = useAuth();
  const navigate = useNavigate();
  globalRouter.navigate = navigate;

  const location = useLocation();

  const noFooterHeaderRoutes = ["/", "/forgot-password", "/reset-password"];

  // Check if the current location matches any of the routes to skip the Footer
  const shouldShowFooter = !noFooterHeaderRoutes.includes(location.pathname);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
      className="App"
    >
      <Toaster richColors expand closeButton />

      {isLoading ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <CircularProgress size={60} sx={{ color: "var(--aqua-1)" }} />
        </Box>
      ) : (
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/colors" element={<ColoursEx />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route element={<AuthGuard />}>
              <Route path="/handle-meetings" element={<Meetings />} />
              <Route path="/tag-meeting" element={<TagMeetings />} />
              <Route path="/response-submitted" element={<ThankYouPage />} />
              <Route
                path="/regularized-attendance"
                element={<RegularizeAttendanceData />}
              />
              <Route path="/add-conveyance" element={<AddConveyance />} />
              <Route
                path="/regularize-meeting-menu"
                element={<RegularizeMeetingMenu />}
              />
              <Route
                path="/regularize-meeting"
                element={<RegularizeMeeting />}
              />
              <Route path="/mark-day" element={<MarkMyDayPage />} />
              <Route path="/profile" element={<ProfilePage />} />

              <Route
                element={
                  <ProtectedRoute
                    role={userDetail?.data?.user?.role}
                    allowedRoles={["admin"]}
                  />
                }
              >
                <Route path="/create-user" element={<CreateUserPage />} />
                <Route path="/delete-user" element={<DeleteUserPage />} />
                <Route path="/upload-imd" element={<UploadImdPage />} />
              </Route>
            </Route>
          </Routes>
        </main>
      )}

      {shouldShowFooter && <Footer />}
      <AddToHomeScreenPrompt />
    </div>
  );
}

export default App;
